import { useRef } from 'react';

import { MdNotifications } from './Notifications.md';
import { NotificationsList } from './NotificationsList/NotificationsList';

import { useOnClickOutside } from '@speeki/react-hooks';

import { useResponsive } from '@utils/hooks/useResponsive';

import { NotificationsWrapper } from './Notifications.styled';

export interface NotificationsProps {
    isOpen?: boolean;
    onClose: () => void;
}

export const Notifications = ({ isOpen, onClose }: NotificationsProps) => {
    const dropdownRef = useRef(null);
    useOnClickOutside(dropdownRef, onClose);

    const isLg = useResponsive('lg');

    if (isLg) return <MdNotifications isOpen={isOpen} onClose={onClose} />;

    return (
        <NotificationsWrapper ref={dropdownRef}>
            <NotificationsList onClose={onClose} />
        </NotificationsWrapper>
    );
};
